import axios from "axios";

const apiUrl = "https://penis-catcher.com/api/";
const apiKey = "421e6726699445a89f79da34f8d146a9";

export const apiRequest = (apiEndpoint, params = {}) => {
  return axios.get(apiUrl + apiEndpoint, {
    params: { ...params, key: apiKey },
  });
};
